export const enum LSkeys {
  OTP_TOKEN = "otpToken",
  AUTH_TOKEN = "auth",
  USER = "user",
  THEME = "theme",
  EMAIL_ALIGNMENT = "emailAllignment",
  LANGUAGE_ID = "languageId",
  SELECTED_LANGUAGE = "selectedLanguage",
  ACCOUNT_STEP = "accountStep",
  SEARCH_HISTORY = "searchHistory",
  USER_TYPE_ID = "userTypeId",
  USER_ID = "userId"
}

export const ValidationConstants = {
  userAccountStrategy: {
    PASSWORD_MIN_LENGTH: 6,
    PASSWORD_MAX_LENGTH: 15,
    PASSWORD_PATTERN: '^(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$',
    NAME_MIN_LENGTH: 3,
    NAME_MAX_LENGTH: 30,
    NAME_PATTERN: "^[A-Za-z ]+$",
    EMAIL_PATTERN: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$",
    WEB_SITE_PATTERN: "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?",
    PHONE_NUMBER: /^[0-9]{5,15}$/,
    RSS_FEED_MIN: 1,
    RSS_FEED_MAX: 1440,
    OTP_PATTERN: "^[0-9]*$",
    PHONE_NUMBER_MAX_LENGTH: 12,
    PHONE_NUMBER_MIN_LENGTH: 5,
    COMPANY_NAME_PATTERN: "^[A-Za-z0-9\\s.&'-]+$",
    PHONE_NUMBER_MAX: 10,
    PHONE_NUMBER_MIN: 10,
  },
  bookingPayload: {
    NO_OF_ITEMS_PATTERN: "^[1-9][0-9]*$",
    NO_OF_ITEMS_MIN: 1,
    NO_OF_ITEMS_MAX: 999999999,
    ITEM_WEIGHT_PATTERN: "^[0-9]+(\\.[0-9]+)?$",
    ITEM_WEIGHT_MIN: 1,
    ITEM_WEIGHT_MAX: 250
  }
}

export enum OrderStatus {
  SEARCHING = "Searching",
  SERACCEPT = "SerAccept",
  ONREACHED = "Onreached",
  ONGOING = "Ongoing",
  CONFIRMED = "Confirmed",
  SERLONGDISTANCE = "SerLongDistance",
  DRIVERSEARCHINGAGAIN = "DriverSearchingAgain",
  HELPERACCEPT = "HelperAccept",
  CURRENTORDERS = "CurrentOrders",
  SERCOMPLETE = "SerComplete",
  SERTIMEOUT = "SerTimeout",
  CONTINUEWITHOUTHELPER = "ContinueWithoutHelper",
  CUSTCANCEL = "CustCancel",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
  SERPAYSUCCESS = "SerPaySuccess",
  DPENDING = "DPending",
  DAPPROVED = "DApproved",
  ORGPENDING = "OrgPending",
  DRIVERASSIGN = "driverAssign",
  DESTARRIVED = "DestArrived"
}

export enum ChargeType {
  OBSTACLE = 'obstacle',
  TOLL_TAX = 'tolltax'
}

export enum serviceTypes {
  BRING_IT_NOW = 4,
  ONLY_HELPER = 10,
}

export enum OrderType {
  FUTURE = '1'
}